import { computed } from 'vue';
import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { useStore } from '@/store';
import { ActionTypes as AuthActionTypes } from '@/store/modules/Auth/actions';
import { useJwtInfo } from '@/composables/useJwtInfo';

let refreshPromise: Promise<void> | null = null;

const onRequest = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  // console.info(`[request] [${JSON.stringify(config)}]`);
  if (config.headers === undefined) {
    config.headers = {};
  }

  const store = useStore();
  const authUser = computed(() => store.getters.authUser);

  if (authUser.value != null && authUser.value.token != null) {
    const { secondsLeft } = useJwtInfo(authUser.value.token);

    if (secondsLeft.value !== null && secondsLeft.value <= 30 && !config.url?.includes('/login/refresh')) {
      // Token läuft in weniger als 30 Sekunden ab
      if (!refreshPromise) {
        refreshPromise = store
          .dispatch(AuthActionTypes.RefreshLogin, undefined)
          .catch(() => {
            // Refresh-Token ungültig oder abgelaufen, Benutzer muss sich neu anmelden
            store.dispatch(AuthActionTypes.Logout, undefined);
          })
          .finally(() => {
            refreshPromise = null;
          });
      }
      await refreshPromise;
    }

    config.headers.Authorization = `Bearer ${authUser.value.token}`;
  }

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  // console.error(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  // console.info(`[response] [${JSON.stringify(response)}]`);
  return response;
};

const onResponseError = async (error: AxiosError): Promise<any> => {
  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
